import { createSelector } from 'reselect';

const selectZone = (state: any) => state.zone;


export const selectCurrentItem = createSelector([selectZone], (zone) => zone.current);

export const selectZoneListItems = createSelector([selectZone], (zone) => zone.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectZoneListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectZoneQueryItems = createSelector([selectZone], (zone) => zone.query);

export const selectCreatedItem = createSelector([selectZone], (zone) => zone.create);

export const selectUpdatedItem = createSelector([selectZone], (zone) => zone.update);

export const selectReadItem = createSelector([selectZone], (zone) => zone.read);

export const selectDeletedItem = createSelector([selectZone], (zone) => zone.delete);

export const selectSearchedItems = createSelector([selectZone], (zone) => zone.search);

export const selectItemsCount = createSelector([selectZone], (zone) => zone.count);

export const selectItemsFilter = createSelector([selectZone], (zone) => zone.filter);